import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import EditGroupListing from '@/modules/manage-member/components/EditGroup/components/EditGroupListing'

function EditGroupPage() {
	return (
		<PageContainer>
			<EditGroupListing />
		</PageContainer>
	)
}

const GuardedEditGroupPage = withUserPermission(EditGroupPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_OPERATOR],
})

export default GuardedEditGroupPage
